var path = 'https://acentrocampo.s3.eu-west-1.amazonaws.com/icons/'

export default {
    icons:[
        path+'9601564832.svg',
        path+'9499690435.svg',
        path+'9380897000.svg',
        path+'9105498798.svg',
        path+'9097028122.svg',
        path+'8767920470.svg',
        path+'8683990314.svg',
        path+'8530978870.svg',
        path+'8412615417.svg',
        path+'7993760639.svg',
        path+'7965442745.svg',
        path+'7928099377.svg',
        path+'7465828697.svg',
        path+'7426067618.svg',
        path+'7409891941.svg',
        path+'7371290584.svg',
        path+'7279419672.svg',
        path+'7242184727.svg',
        path+'7115675134.svg',
        path+'6841901037.svg',
        path+'6663212949.svg',
        path+'6599022735.svg',
        path+'6322194955.svg',
        path+'6267251821.svg',
        path+'6242996945.svg',
        path+'6234271262.svg',
        path+'6221214500.svg',
        path+'5940048518.svg',
        path+'5851990046.svg',
        path+'5783366348.svg',
        path+'5649125296.svg',
        path+'5555512728.svg',
        path+'5473634801.svg',
        path+'5399331582.svg',
        path+'5272954751.svg',
        path+'5177137473.svg',
        path+'5000557599.svg',
        path+'4893201368.svg',
        path+'4359762672.svg',
        path+'4142282462.svg',
        path+'4105083646.svg',
        path+'3794121318.svg',
        path+'3773171066.svg',
        path+'3601011373.svg',
        path+'3467550448.svg',
        path+'3435582774.svg',
        path+'2908586663.svg',
        path+'2844730863.svg',
        path+'2041853960.svg',
        path+'1608302457.svg',
        path+'1340569463.svg',
        path+'1312473556.svg',
        path+'1221845526.svg',
        path+'1220243093.svg',
        path+'1051111343.svg',
        path+'995575847.svg',
        path+'666567652.svg',
        path+'657676922.svg',
        path+'antepost.svg',
    ]
}